<template>
    <SOSlotModal  
        :modal-title="title"
        :modal-id="id"
        :no-padding="true"
        @close="!loading && close()"
    >
        <template v-slot:modal-body>
            <div class="p-4" v-html="body">
            </div>
        </template>
        <template v-slot:modal-footer>
            <div class="px-4">
                <SOButton
                    :disable="loading"
                    :loading="loading"
                    text="Ya, ubah"
                    :primary="true"
                    :full="true"
                    @action="confirm()"
                />
            </div>
        </template>
    </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";

export default {
    name: "confirmModal",
    components: {
        SOSlotModal,
        SOButton,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: "Konfirmasi perubahan",
        },
        body: {
            type: String,
            default: "Yakin ingin mengubah pengaturan Ambil Tanpa Lunasi?",
        },
        type: {
            type: String,
            default: "default",
        },
    },
    data () {
        return {
            id:"confirm-modal",
            requestChange: null,
        }
    },
    methods: {
        confirm() {
            if (this.type == "default") {
                this.$emit("confirmChange", this.requestChange);
            }
            else {
                switch (this.type) {
                    case 'deleteOutlet':
                        this.$emit("confirmDeleteOutlet", this.requestChange);
                        break;
                
                    default:
                        break;
                }
            }
        },
        open(requestChange) {
            this.requestChange = requestChange
            $("#" + this.id).modal("show");
        },
        close() {
            $("#" + this.id).modal("hide");
            setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
    },    
    computed: {
    },
}
</script>

<style>

</style>